export default __webpack_public_path__ + "static/media/cardSVG.59c80724.svg";